<template>
    <Sidebar v-if="$store.state.user_data"/>
    <Content class="landing-content" :hide_alert="true">
        <Scrollbar class="right-list" v-if="$store.state.user_data && $store.state.user_data.merchant_accounts.length > 1 && $store.state.user_data.status !== 0 ">
            <div class="list" 
                :class="{ 'is-loading': is_loading }">
                <div class="landing-card" v-for="(item, key) in $store.state.user_data.merchant_accounts" :key="key"
                    @click="select(item)">
                    <div class="box">
                        <div class="user" :title="item.merchant_display_name">
                            <figure class="avatar"><img :src="item.brand_logo" /></figure>
                            <p>
                                <strong v-html="item.merchant_display_name"></strong>
                                <!-- <span>Merchant <b>• Primary workspace</b></span> -->
                                <span v-if="$store.state.merchant_disabeld">Please contact your Anchor representative to renew your account.</span>
                            </p>
                        </div>
                        <div class="btn" >
                            <Button size="40" color="dark-blue" v-if="!$store.state.merchant_disabeld">
                                <svg-icon name="arrow-next" />
                            </Button>
                            <div class="alert" v-else>Your Anchor workspace has expired</div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </Scrollbar>
        <div class="empty-content" v-else-if="$store.state.user_data.merchant_accounts || $store.state.user_data.status===0">
            <img src="@/assets/images/no-merchant.png" />
            <h2>You have not been added to an Anchor workspace yet.</h2>
            <p>Please reach out to your workspace admin to access this page or contact us if you believe there has been a mistake.</p>
        </div>
    </Content>
</template>

<script>
import "@/assets/svg/pen.svg?sprite";
import "@/assets/svg/remove.svg?sprite";
import "@/assets/svg/question.svg?sprite";

import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Sidebar from '@/components/Sidebar.vue';
import { usePermissionFunction } from '@/components/ui/permissionFunction';

export default {
    name: 'Landing',

    data() {
        return {
            is_loading: false,
            footer_data: {
                menus: [
                    // {
                    //     text: 'Help center',
                    //     tooltip_text: 'Help center',
                    //     to: '/help', //'https://support.motom.me/',
                    //     icon: 'help',
                    // },
                ]
            }
        }
    },
    setup() {
        const { switchOrgItem } = usePermissionFunction();
        return {
            switchOrgItem, 
        };
    },
    components: {
        Button,
        Content,
        Scrollbar,
        Sidebar
    },

    methods: {
        select(item) {
            this.is_loading = true;
            if(this.$store.state.user_data.status===0){
                return
            }

            this.$ajax(`/select-current-merchant-account`, {
                method: 'post',
                data: {
                    merchant_account_id: item.id
                },
            }).then(res => {
                this.$store.state.user_data.merchant_account = item;
                if (item.enable_creators_count === 0 ) {
                    window.location.replace('/creator/get-started');
                } else {
                    window.location.href = '/creator/list'
                    //window.location.replace('/creator/list');
                }
                this.switchOrgItem();
                this.is_loading = false;
            });
        },
    },

    mounted() {
        if(this.$store.state.user_data.status===0){
            return
        }
        
        this.$ajax('/me', {
            method: 'post',
        }).then(res => {
            const obj = res.data.data;

            this.$store.state.chatroom_url = res.data.data?.chatroom_public_url;

            if (!this.$route.query.is_onboard && obj.merchant_accounts.length > 1) {
                this.$ajax(`/select-current-merchant-account`, {
                    method: 'post',
                    data: {
                        merchant_account_id: 0
                    },
                });
                this.$store.state.user_data.merchant_account = null;
            } 
            
            if (this.$route.query.is_onboard) {
                this.$store.state.user_data.merchant_account = obj.merchant_account;
            }


            if (obj && obj.merchant_accounts.length === 1) {
                if (obj.merchant_account) {
                    if (obj.merchant_account.enable_creators_count === 0) {
                        this.$router.replace('/creator/get-started');
                    } else {
                        this.$router.replace('/creator/list');
                    }
                } else {
                    if (obj.merchant_accounts[0].enable_creators_count === 0) {
                        this.$router.replace('/creator/get-started');
                    } else {
                        this.$router.replace('/creator/list');
                    }
                }
            }
        });

    },
}
</script>

<style lang="scss">
.landing-sidebar {
    // max-width: 360px;
    // min-width: 320px;
    // width: 25%;
    width: 260px;
    background-color: var(--dark-blue);
    color: white;

    .scrollbar-content {
        height: 100%;
        overflow: auto;
        display: grid;
        grid-template-rows: 1fr auto;
        grid-template-columns: 100%;
    }

    .menu,
    .menus {
        padding: 16px;

        li {
            margin: 16px 0;
        }

        a {
            color: var(--black-40);
            display: flex;
            align-items: center;
            height: 40px;
            border-radius: 20px;
            font: var(--font-fg-16);
            padding: 0 18px;


            svg {
                height: 20px;
                width: 20px;
                margin-right: 8px;
            }

            span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .svg-icon--analytics,
            .svg-icon--help {
                height: 18px;
                width: 18px;
                position: relative;
                left: 1px;

                &+span {
                    position: relative;
                    left: 2px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

            }

            .svg-icon--setting {
                height: 26px;
                width: 26px;

                &+span {
                    position: relative;
                    left: -3px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            &:hover {
                color: white;
            }

            &.router-link-active,
            &.router-link-exact-active {
                background: rgba(255, 255, 255, 0.15);
                border: 1px solid rgba(255, 255, 255, 0.05);
                color: white;
            }
        }
    }

    footer {
        .ui-usage-large {
            margin: 0 16px;
        }

        .menu {
            padding-bottom: 8px;

            li {
                margin: 0 0 4px;
            }
        }

        .user-info {
            margin: 16px 32px 24px;
            display: flex;
            align-items: center;
            cursor: pointer;
            color: var(--black-40);

            .avatar {
                height: 28px;
                width: 28px;
                min-width: 28px;
                background-color: var(--black-20);
                border: 2px solid var(--black-75);
                overflow: hidden;
                border-radius: 50%;

                img {
                    height: 100%;
                    width: 100%;
                    display: block;
                    object-fit: cover;
                }
            }

            h2 {
                padding: 0 8px;
                display: block;
                font: var(--font-fg-16);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            svg {
                height: 14px;
                width: 14px;
                display: block;
            }
        }

        .user-data {
            position: relative;

            // &:hover {

            //     .user-info {
            //         color: white;
            //     }

            //     .sub-menu {
            //         transform: translate(0%, 0);
            //         opacity: 1;
            //         pointer-events: unset;
            //     }
            // }

            &.open {

                .user-info {
                    color: white;
                }

                .sub-menu {
                    transform: translate(0%, 0);
                    opacity: 1;
                    pointer-events: unset;
                }
            }
        }

        .sub-menu {
            position: fixed;
            background-color: white;
            box-shadow: var(--bot-2dp);
            left: 180px;
            z-index: 99;
            border-radius: 8px;
            // margin-left: 100%;
            width: 170px;
            margin-top: -80px;
            padding: 5px 0;
            transition: all .3s ease-in-out;
            transform: translate(25%, 0);
            opacity: 0;
            pointer-events: none;

            &:after {
                right: 100%;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(0, 0, 0, 0);
                border-right-color: #fff;
                border-width: 6px;
                bottom: 20px;
            }

            li>span,
            a {
                display: block;
                padding: 8px 12px;
                color: var(--black-90);
                cursor: pointer;
                font: var(--font-fg-14);

                &:hover {
                    background-color: var(--bg-02);
                }
            }
        }

        .bottom-box {
            margin: 16px 32px 32px;
            display: flex;
            align-items: center;

            .copyright {
                height: 32px;
                font-size: 12px;
                color: var(--black-40);
                flex: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        }
    }
}

.landing-content {
    background-color: #F6F8FC;
    padding: 24px;

    .list {
        display: flex;
        flex-wrap: wrap;
        //padding: 24px;
        // background-color: #F6F8FC;
        // border-radius: 16px 0 0 0;

        &.is-loading {
            opacity: .5;
            pointer-events: none;
        }
    }

    .landing-card {
        width: calc(25% - 24px);
        margin: 12px;

        @media screen and (max-width: 1920px) {
            width: calc(33.3333% - 24px);
        }

        @media screen and (max-width: 1280px) {
            width: calc(50% - 24px);
        }

        @media screen and (max-width: 768px) {
            width: calc(100% - 24px);
        }

        .box {
            border-radius: 10px;
            overflow: hidden;
            background-color: white;
            display: block;
            cursor: pointer;
        }

        .user {
            display: flex;
            padding: 24px;
            align-items: center;

            .avatar {
                height: 62px;
                width: 62px;
                min-width: 62px;
                background-color: var(--white);
                overflow: hidden;
                border-radius: 50%;
                border: solid 1px var(--black-20);

                img {
                    height: 100%;
                    width: 100%;
                    display: block;
                    object-fit: contain;
                }
            }

            p {
                padding-left: 16px;
                width: calc(100% - 78px);

                strong {
                    display: block;
                    line-height: 1.2;
                    letter-spacing: 1px;
                    font: var(--font-demi-28);
                    color: var(--dark-blue);
                    margin-bottom: 1px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                span {
                    // font-size: 12px;
                    color: var(--black-90);
                    font-size: 16px;

                    b {
                        font-weight: 700;
                    }
                }
            }
        }

        .btn {
            padding: 16px 24px;
            background-color: var(--border);
            display: flex;
            justify-content: flex-end;

            .ui-button {
                width: 180px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    display: block;
                    height: 18px;
                    width: 18px;
                }
            }

            .alert{
                color:var(--red);
                text-align: center;
                width:100%;
                font:var(--font-med-16);
            }
        }
    }

    .empty-content {
        width: 100%;
        height: 100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        h2 {
            font: var(--font-fg-20);
        }

        p {
            font: var(--font-fg-16);
        }
    }
}</style>